import { Form } from "react-bootstrap";

// Matches the API's MaxRecipeNameLength / the recipes.name column width.
export const MAX_TITLE_LENGTH = 255;

type TitleInputProp = {
  value: string;
  setTitle: React.Dispatch<React.SetStateAction<string>>;
};

const TitleInput = ({ value, setTitle }: TitleInputProp) => {
  const remaining = MAX_TITLE_LENGTH - value.length;
  return (
    <Form.Group>
      <Form.Control
        placeholder="Title"
        name="name"
        value={value}
        maxLength={MAX_TITLE_LENGTH}
        aria-describedby="title-length"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTitle(e.target.value)}
        required
      ></Form.Control>
      <Form.Text id="title-length" className={remaining <= 0 ? "text-danger" : "text-muted"}>
        {remaining <= 30 ? `${value.length}/${MAX_TITLE_LENGTH} characters` : ""}
      </Form.Text>
    </Form.Group>
  );
};

export default TitleInput;
